<h3>{{ event.date | amFromUnix | amDateFormat:'DD/MM/YYYY' }} | {{ (event.user | resolveUser).email }}</h3>
<div class="d-flex flex-wrap">
  <app-category-tag class="d-block mb-3" [category]="category.id"></app-category-tag>
</div>
<p *ngIf="event.locationTown && event.locationLga" class="mb-3 d-block">Location: {{ event.locationTown }}, {{ (event.locationLga | resolveLga).name }}</p>
<p *ngIf="event.notes" class="mb-3 d-block font-italic">Notes: {{ event.notes }}</p>
<mat-divider></mat-divider>
<br/>
<h1>Attendees</h1>
<mat-list class="odd-even-list">
  <mat-list-item>
    <div class="row">
      <h3 class="col-9 m-0">Property</h3>
      <h3 class="col-3 m-0 text-right">Attendees</h3>
    </div>
  </mat-list-item>
  <mat-list-item *ngFor="let prop of properties" class="mr-0 ml-0" (click)="selectAttendee(prop)">
    <div class="row">
      <span class="col-9 ellipsis clickable" style="line-height: 28px; font-size: medium">
        <span class="font-italic" [matTooltip]="prop.id">{{ prop.id | formatPropertyId }}:</span> {{ prop.name ? prop.name + ', ' : '' }}{{ prop.address }}
      </span>
      <span class="col-3 text-right">
            {{ propertyAttendees[prop.id] || 0 }}
      </span>
    </div>
  </mat-list-item>
</mat-list>
